import { Component, Input } from '@angular/core';
import { Language } from '@app/core/models/interfaces/language.interface';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-language-selector',
  templateUrl: './language-selector.component.html',
  styleUrls: ['./language-selector.component.scss'],
})
export class LanguageSelectorComponent {
  /** Flag for white background container */
  @Input() lighting = false;
  /** Languages */
  languages: Language[] = [
    {
      name: 'En',
      code: 'en',
      flag: 'assets/img/en.png',
    },
    {
      name: 'Es',
      code: 'es',
      flag: 'assets/img/es.png',
    },
  ];
  /** Language selected */
  languageSelected: Language;

  constructor(private translate: TranslateService) {
    const currentLang = localStorage.getItem('LANGUAGE');
    if (currentLang) {
      this.languageSelected = JSON.parse(currentLang);
    } else {
      this.languageSelected =
        this.languages.find(lang => lang.code === this.translate.getDefaultLang()) ?? this.languages[0];
      localStorage.setItem('LANGUAGE', JSON.stringify(this.languageSelected));
    }
    this.translate.setDefaultLang(this.languageSelected.code);
  }

  langChanged(selectedLang: Language) {
    this.languageSelected = selectedLang;
    this.translate.use(selectedLang.code);
    this.translate.setDefaultLang(selectedLang.code);
    const languageSelectorButton: HTMLElement = document.getElementById(
      'dropdownLanguageSelectorButton'
    ) as HTMLElement;
    languageSelectorButton.click();
    localStorage.setItem('LANGUAGE', JSON.stringify(this.languages.find(lang => lang.code === selectedLang.code)));
  }
}
